import React, { Suspense, memo } from "react";
import styles from "./PostLogin.module.scss";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "@/store/slices/globalSlice";
import { type RootState } from "@/store/rootReducer";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import DashboardHeaderComponent from "@/components/DashboardHeader/DashboardHeaderComponent";

const HomeLayout: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const sidebarOpen = useSelector(
    (state: RootState) => state.global.sidebarOpen
  );

  const toggleSidebarOpen = (flag: boolean) => (e: React.MouseEvent) => {
    e.stopPropagation();
    if (sidebarOpen !== flag) {
      dispatch(setSidebarOpen(flag));
    }
  };

  const isDashboardRoute = location.pathname === "/dashboard";

  const SuspenseLoader = () => (
    <div className={styles.suspenseLoader}>
      <Loader />
    </div>
  );

  return (
    <div className={styles.layout}>
      <Sidebar toggleSidebarOpen={toggleSidebarOpen} />
      <div className={styles.rightSideContainer}>
        {/* {isDashboardRoute ? <DashboardHeaderComponent /> : <Navbar />} */}
        <Navbar className={styles.navbar} />
        <div className={styles.outletDiv}>
          <Suspense fallback={<SuspenseLoader />}>
            <ErrorBoundary resetKey={location.pathname}>
              <Outlet />
            </ErrorBoundary>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default memo(HomeLayout);
